import React from 'react';

const OfferContext = React.createContext();

export default OfferContext;
